import { Badge } from '@mantine/core';
import { IconStarFilled } from '@tabler/icons-react';

export function DefaultTemplateBadge({ label = 'Default' }: { label?: string }) {
  return (
    <Badge
      variant="light"
      color="brand"
      size="sm"
      radius="xl"
      leftSection={<IconStarFilled size={10} aria-hidden />}
      style={{ flexShrink: 0 }}
    >
      {label}
    </Badge>
  );
}
